import { Component, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  standalone: false,
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  loader = inject(LoaderService);
}
